import ERROR_MESSAGE from "../constants/message";

const handleError = (e: any): string => {
  let errorMessage: string = ""
  if (e?.status === 400) {
    errorMessage = ERROR_MESSAGE.BAD_REQUEST.MESSAGE;
  } else if (e?.status === 401) {
    errorMessage = ERROR_MESSAGE.UNAUTHORIZED.MESSAGE;
  } else if (e?.status === 403) {
    errorMessage = ERROR_MESSAGE.FORBIDDEN.MESSAGE;
  } else if (e?.status === 404) {
    errorMessage = ERROR_MESSAGE.NOT_FOUND.MESSAGE;
  } else if (e?.status === 500) {
    errorMessage = ERROR_MESSAGE.SERVER_ERROR.MESSAGE;
  } else {
    errorMessage = ERROR_MESSAGE.DEFAULT.MESSAGE;
  }

  return errorMessage;
}

export default handleError;